import { concatWithPrefix } from '@sravni/cosago-react-library/lib/utils';

import { pluralizeIso8601Period } from 'shared/lib';
import { formatNumber } from 'shared/lib/formatters';

import type { TCreditPurposeFormFields } from 'entities/creditForm';

import { AccordionHeaderParamsTexts } from './AccordionHeaderParams.texts';

export const formatCreditPurposeDescription = (data: TCreditPurposeFormFields) => {
  const { amount, period } = data;
  let description = '';

  if (amount) {
    description = concatWithPrefix(description, `${formatNumber(Number(amount))} ₽`);
  }

  if (period) {
    description = concatWithPrefix(description, pluralizeIso8601Period(period.value), ' на ');
  }

  return description || AccordionHeaderParamsTexts.HeaderDefaultDescription;
};
